module.exports = __webpack_public_path__ + "static/media/Android.64f1b36f.svg";